import {Checkbox, classNames, layout, PushButton, TextInput} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback, useState} from "react";
import {stylesheet} from "typestyle";
import {Tool} from "./Tool";
import {MockToolProps} from "./types";

export function NfcReaderTool({mockController, align}: MockToolProps) {
	const [uid, setUid] = useState("");

	const handlePresentCard = useCallback(() => {
		mockController.nfcReader.presentCard({uid});
	}, [uid]);

	const handleRemoveCard = useCallback(() => {
		mockController.nfcReader.removeCard();
	}, []);

	return (
		<Tool label="NFC Reader" align={align}>
			<div className={classNames(layout.paddingLarge)}>
				<Checkbox
					onChange={checked => mockController.setNfcEnabled(checked)}
					defaultChecked={mockController.isNfcEnabled()}
				>
					Connected
				</Checkbox>
				<div className={styles.inputContainer}>
					<TextInput value={uid} onChange={setUid} placeholder="Card UID" outline className={styles.input} />
				</div>
				<div className={classNames(layout.horizontal, layout.spaceBetween)}>
					<PushButton onClick={handlePresentCard} primary>
						Present card
					</PushButton>
					<PushButton onClick={handleRemoveCard} primary>
						Remove card
					</PushButton>
				</div>
			</div>
		</Tool>
	);
}

const styles = stylesheet({
	input: {
		width: "12em",
	},
	inputContainer: {
		paddingBottom: "1em",
	},
});
